import config from '../config.js';
import isProduction from '../isProduction/index.js';
export default config.isDebug && !isProduction;
//# sourceMappingURL=index.js.map